import { Controller } from "@hotwired/stimulus";
import { animate } from "animejs";

export default class extends Controller {
  static values = { persistent: Boolean };

  connect() {
    if (!this.persistentValue) {
      this._timer = setTimeout(() => this._dismiss(), 4000);
    }
  }

  disconnect() {
    clearTimeout(this._timer);
  }

  dismiss() {
    this._dismiss();
  }

  _dismiss() {
    animate(this.element, {
      opacity: 0,
      translateY: "-0.75rem",
      duration: 250,
      ease: "outQuad",
      onComplete: () => this.element.remove(),
    });
  }
}
